module.exports = __webpack_public_path__ + "img/outdoor.26d4dbdc.png";